import { Tooltip } from "antd";
import { useTopic } from "../../hooks/use-topics";

interface IBasicTabProps {
  style?: {};
  title: string;
  tooltip: string;
  children: any;
}

export const BasicTab = ({
  style = {},
  title,
  tooltip,
  children
}: IBasicTabProps) => {
  const { activeTab, setActiveTab } = useTopic();

  return (
    <Tooltip title={tooltip}>
      <div
        className="doc-tab-label"
        style={{
          cursor: activeTab !== title ? "pointer" : null,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          overflow: "hidden",
          ...style
        }}
        onClick={() => {
          setActiveTab(title);
        }}
      >
        {children}
      </div>
    </Tooltip>
  );
};
